import { Product } from '~/models/product/Product'
import { IStoredProduct } from '~/store/documents/favorites/products/local-store/models/stored-product/IStoredProduct'

export class StoredProduct {
  public static toProduct({ ref, name, thumb }: IStoredProduct) {
    return new Product(ref, name, thumb)
  }
}
